import { axios } from '@/utils/request'

const api4 = {
  accessory: '/stock/faulty'
}
const api6 = {
  accessory: '/stock/backOrder'
}

const api5 = {
  accessory: '/stock/shipping'
}
const api = {
  accessory: '/stock/accessory',
  accessory2: '/stock/shipping',
  accessory3: '/stock/backOrder'
}

const api2 = {
  accessory: '/stock/config'
}

const api3 = {
  accessory: '/stock/selectutils'
}


// 查询文件
export function getBackFile (parameter) {
  return axios({
    url: api.accessory3 + '/getBackFile',
    method: 'get',
    params: parameter
  })
}

// 调拨文件删除 禁用
export function delBackFile (parameter) {
  return axios({
    url: api.accessory3 + '/delBackFile',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 查询文件
export function getShippingFile (parameter) {
  return axios({
    url: api.accessory2 + '/getShippingFile',
    method: 'get',
    params: parameter
  })
}

// 调拨文件删除 禁用
export function delShippingFile (parameter) {
  return axios({
    url: api.accessory2 + '/delShippingFile',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 退货单数组物流信息
export function updateBackLogistics (parameter) {
  return axios({
    url: api.accessory3 + '/updateBackLogistics ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  })
}



// 调货/调拨单数组物流信息
export function updateLogisticsStatus (parameter) {
  return axios({
    url: api.accessory2 + '/updateLogisticsStatus ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  })
}

// 调拨 根据用户ID查询名下仓库
export function getStockByUserId (parameter) {
  return axios({
    url: api3.accessory + '/getStockByUserId ',
    method: 'get',
    params: parameter

  })
}

// 调拨 获取主库信息
export function getMainStore (parameter) {
  return axios({
    url: api3.accessory + '/getMainStore ',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 报损 详情
export function getonefaulty  (parameter) {
  return axios({
    url: api4.accessory + '/getonefaulty ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  })
}

// 报损 审核
export function auditOrder  (parameter) {
  return axios({
    url: api4.accessory + '/auditOrder ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  })
}


// 根据仓库类型查询仓库
export function selectStoreByStoreType (parameter) {
  return axios({
    url: api3.accessory + '/selectStoreByStoreType',
    method: 'get',
    params: parameter,


  })
}

export function selectStorageAccessory (parameter) {
  return axios({
    url: api3.accessory + '/selectStorageAccessory',
    method: 'get',
    params: parameter,

  })
}

export function delorder (parameter) {
  return axios({
    url: api4.accessory + '/delorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function forbiddenorder (parameter) {
  return axios({
    url: api4.accessory + '/forbiddenorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function addfaulty (parameter) {
  return axios({
    url: api4.accessory + '/addfaulty',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getonebackorder (parameter) {
  return axios({
    url: api6.accessory + '/getonebackorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function editbackorder (parameter) {
  return axios({
    url: api6.accessory + '/editbackorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function backaccessory (parameter) {
  return axios({
    url: api6.accessory + '/backaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function addbackorder (parameter) {
  return axios({
    url: api6.accessory + '/addbackorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function selectorderlist (parameter) {
  return axios({
    url: api4.accessory + '/selectorderlist',
    method: 'get',
    params: parameter
  })
}

export function selectaccessory (parameter) {
  return axios({
    url: api3.accessory + '/selectaccessory',
    method: 'get',
    params: parameter,

  })
}

export function selectstore (parameter) {
  return axios({
    url: api3.accessory + '/selectstore',
    method: 'get',
    params: parameter,

  })
}

export function getAccessoryList (parameter) {
  return axios({
    url: api.accessory + '/accessorylist',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function saveAccessory (parameter) {
  return axios({
    url: api.accessory+(parameter.accessoryId > 0 ? 'editaccessory' : '/addaccessory'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editaccessory (parameter) {
  return axios({
    url: api.accessory+(parameter.accessoryId > 0 ? 'editaccessory' : '/editaccessory'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delAccessory1 (parameter) {
  return axios({
    url: api.accessory + '/delaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delAccessoryTwo (parameter) {

  return axios({
    url: api.accessory + '/forbidden',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function configSave (parameter) {

  return axios({
    url: api.accessory + '/config',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function selAccessory (parameter) {
  return axios({
    url: api2.accessory + '/getoneaccessory',
    method: 'post',
    params: parameter,
  })
}

export function addallocation (parameter) {
  return axios({
    url: api5.accessory + '/addallocation',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function shippinginaccessory (parameter) {
  return axios({
    url: api5.accessory + '/shippinginaccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editshpping (parameter) {
  return axios({
    url: api5.accessory + '/editshpping',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}



export function getoneshpping (parameter) {
  return axios({
    url: api5.accessory + '/getoneshpping',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function addshpping (parameter) {
  return axios({
    url: api5.accessory + '/addshpping',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectenterprise (parameter) {
  return axios({
    url: api3.accessory + '/selectenterprise',
    method: 'get',
    params: parameter,

  })
}

export function selectenterprise2 (parameter) {
  return axios({
    url: api3.accessory + '/selectconfigmodel',
    method: 'get',
    params: parameter,

  })
}
export const accessoryExport = api.accessory + '/export'
